export function isDeliverToFulfillmentCenter(order) {
  return Boolean(order.deliverToFulfillmentCenter);
}